import React from 'react';
import styled from 'styled-components';
import { system } from 'styled-system';
import { ComposedStyleFns } from '../theme/theme';
import { colorScheme } from '../utils/utils';
const GridStyleFns = system({
  gap: {
    property: 'gridGap',
    scale: 'space'
  },
  rowGap: {
    property: 'gridRowGap',
    scale: 'space'
  },
  columnGap: {
    property: 'gridColumnGap',
    scale: 'space'
  },
  column: {
    property: 'gridColumn'
  },
  row: {
    property: 'gridRow'
  },
  area: {
    property: 'gridArea'
  },
  autoFlow: {
    property: 'gridAutoFlow'
  },
  autoRows: {
    property: 'gridAutoRows'
  },
  autoColumns: {
    property: 'gridAutoColumns'
  },
  templateRows: {
    property: 'gridTemplateRows'
  },
  templateColumns: {
    property: 'gridTemplateColumns'
  },
  templateAreas: {
    property: 'gridTemplateAreas'
  },
  placeItems: {
    property: 'placeItems'
  }
});
const StyledGrid = /*#__PURE__*/styled.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "sc-1v3k2wr-0"
})(["", " ", " ", " display:grid;"], ComposedStyleFns, GridStyleFns, colorScheme);
/**
 * @public
 */
export const Grid = props => React.createElement(StyledGrid, {
  ...props
});